import type { Read } from '@signalvote/data';

/** What to say in place of `what` when its read could not answer; null otherwise. */
export function unreadyMessage(read: { status: string }, what: string): string | null {
  if (read.status === 'failed') return `Couldn't load ${what}. Refresh to try again.`;
  if (read.status === 'offline') return `You're offline, so ${what} can't load.`;
  return null;
}

/** True once a read has settled one way or the other, so a form waiting on it can stop waiting. */
export function settled(read: { status: string }): boolean {
  return read.status !== 'idle' && read.status !== 'loading';
}
